// import React from 'react';
// import PropTypes from 'prop-types';
// import { useFormContext, Controller } from 'react-hook-form';
// import { TextField } from '@mui/material';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers';

// RHFDateTimeField.propTypes = {
//   name: PropTypes.string.isRequired,
//   disablePast: PropTypes.bool, // Optional prop to disable past dates and times
// };

// RHFDateTimeField.defaultProps = {
//   disablePast: false, // By default, do not disable past dates and times
// };

// export default function RHFDateTimeField({ name, disablePast, mode, InputProps, disabled, ...other }) {
//   const { control } = useFormContext();
//   const minDateTime = disablePast ? new Date() : undefined; // Disable past dates and times based on the prop

//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field, fieldState: { error } }) => {
//         return (
//           <LocalizationProvider dateAdapter={mode === 'time' ? AdapterDayjs : AdapterDateFns}>
//             {mode === 'time' ? (
//               <TimePicker
//                 {...field}
//                 ampm={false}  // Use 24-hour format
//                 views={['hours', 'minutes']}
//                 inputFormat="HH:mm"
//                 disabled={disabled}
//                 minutesStep={5}
//                 value={field.value || null}
//                 onChange={(newValue) => field.onChange(newValue)}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     error={!!error}
//                     helperText={error?.message}
//                     fullWidth
//                     variant="outlined"
//                     {...other}
//                   />
//                 )}
//               />

//             ) : (
//               <DateTimePicker
//                 {...field}
//                 ampm={false}  // Use 24-hour format
//                 inputFormat="dd/MM/yyyy HH:mm"
//                 value={field.value || null}
//                 minDateTime={minDateTime}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     error={!!error}
//                     helperText={error?.message}
//                     fullWidth
//                     variant="outlined"
//                     {...other}
//                   />
//                 )}
//               />
//             )}
//           </LocalizationProvider>
//         );
//       }}
//     />
//   );
// }


import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

RHFDateTimeField.propTypes = {
  name: PropTypes.string.isRequired,
  disablePast: PropTypes.bool, // Disable past dates and times
  mode: PropTypes.oneOf(['dateTime', 'time']), // Mode to switch between dateTime and time pickers
  startTime: PropTypes.any, // Start time value for validation
  isEndTime: PropTypes.bool, // Whether this is the end time picker
  minDateTimeFromNowHours: PropTypes.number, // Min datetime = now + N hours (for dateTime mode; disables selection before that)
};

RHFDateTimeField.defaultProps = {
  disablePast: false,
  mode: 'dateTime',
  startTime: null,
  isEndTime: false,
  minDateTimeFromNowHours: null,
};

export default function RHFDateTimeField({ name, disablePast, mode, mTime, startTime, isEndTime, minDateTimeFromNowHours, disabled, ...other }) {
  const { control } = useFormContext();

  // Compute minTime if this is an endTime picker and startTime exists
  const minTime = isEndTime && startTime ? dayjs(startTime) : null;
  const maxTime = mTime ? dayjs().hour(14).minute(0) : null; // 14:00 = 2:00 PM

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // When minDateTimeFromNowHours is set: disable past dates (min = start of today); when selected date is TODAY, restrict time to current + 1h onwards
        const selectedDateIsToday = field.value && dayjs(field.value).isSame(dayjs(), 'day');
        const minDateTime = minDateTimeFromNowHours != null
          ? (selectedDateIsToday ? dayjs().add(minDateTimeFromNowHours, 'hour').add(1, 'minute').toDate() : dayjs().startOf('day').toDate())
          : (disablePast ? new Date() : undefined);

        return (
          <LocalizationProvider dateAdapter={mode === 'time' ? AdapterDayjs : AdapterDateFns}>
            {mode === 'time' ? (
              <TimePicker
                {...field}
                ampm={false} // 24-hour format
                views={['hours', 'minutes']}
                inputFormat="HH:mm"
                disabled={disabled}
                minutesStep={5}
                value={field.value || null}
                minTime={minTime}
                maxTime={maxTime}
                onChange={(newValue) => field.onChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!error}
                    helperText={error?.message}
                    fullWidth
                    size="small"
                    variant="outlined"
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      sx: {
                        fontSize: 10,
                        '&:not(.MuiInputLabel-shrink)': {
                          transform: 'translate(14px, 12px) scale(1)',
                        },
                      },
                    }}
                    {...other}
                  />
                )}
              />
            ) : (
              <DateTimePicker
                {...field}
                ampm={false} // 24-hour format
                inputFormat="dd/MM/yyyy HH:mm"
                value={field.value || null}
                minDateTime={minDateTime}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!error}
                    helperText={error?.message}
                    fullWidth
                    size="small"
                    variant="outlined"
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      sx: {
                        fontSize: 10,
                        '&:not(.MuiInputLabel-shrink)': {
                          transform: 'translate(14px, 12px) scale(1)',
                        },
                      },
                    }}
                    {...other}
                  />
                )}
              />
            )}
          </LocalizationProvider>
        );
      }}
    />
  );
}
